import { render, staticRenderFns } from "./InvestorDropOffsList.vue?vue&type=template&id=ab6bc28c&"
import script from "./InvestorDropOffsList.vue?vue&type=script&lang=js&"
export * from "./InvestorDropOffsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports